import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'


export type TOrderDataComponentService = {
  payload: {
    entityType: string
    filter: string
    inputValue: string,
    dataInclusao?: string
  }
}

export const orderFormDataComponentService = async ({
  payload,
}: TOrderDataComponentService): Promise<ResponseAPI> => {
  const url = `entidade/${payload.entityType}/${payload.filter}/${payload.inputValue}${payload.dataInclusao ? `/${payload.dataInclusao}` : ''}`;
  const response = await api.get(url);
  return response.data;
}